import { useMutation, useQueryClient } from '@tanstack/react-query';
import { keys } from '@/api/queryKeys';
import { settingsApi } from '../api/settingsApi';
import type { ProviderNetwork } from '../api/types';

export function useUpdateProviderNetwork() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ providerId, data }: { providerId: string; data: Partial<ProviderNetwork> }) =>
      settingsApi.updateProviderNetwork(providerId, data),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: keys.settings.providers });
    },
  });
}
